import { Translation } from '@mindtickle/ui-shell-core/Intl';

import type { ComponentEnhancer } from 'recompose';
import { useUserAuth } from '~/components/Auth';

const DEFAULT_LOCALE = 'en';

const withTranslations = <P extends {}>({
  localeBaseUrl,
  loader = <></>,
  skipCompanySpecificMessagesCheck = false,
}: {
  localeBaseUrl?: string;
  loader?: React.ReactElement;
  skipCompanySpecificMessagesCheck?: boolean;
}) => {
  const enhancer = (Component: React.ComponentType<P>) => (props: P) => {
    const { locale = DEFAULT_LOCALE, tempFeatureConfig = {} } = useUserAuth();

    let _localeBaseUrl = localeBaseUrl;
    if (!skipCompanySpecificMessagesCheck) {
      const hasCompanySpecificMessageDigest = !!tempFeatureConfig?.loadCompanySpecificMessageDigest;

      _localeBaseUrl =
        locale === DEFAULT_LOCALE && !hasCompanySpecificMessageDigest ? undefined : localeBaseUrl;
    }

    return (
      <Translation.Provider localeBaseUrl={_localeBaseUrl} loader={loader}>
        <Component {...props} />
      </Translation.Provider>
    );
  };
  return (enhancer as unknown) as ComponentEnhancer<P, P>;
};

export default withTranslations;
